import React from "react";
import { Container, Grid } from "@mui/material";
import Page from "src/components/Page";
import { makeStyles } from '@mui/styles';
import Header from "./Header";
import { useLocation } from "react-router-dom";
import DistributorEditForm from "./DistributorEditForm";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  container: {
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 64,
      paddingRight: 64,
    },
  },
}));

function DistributorTypeEdit() {
  const classes = useStyles();
  const { state } = useLocation();
  console.log("STATE", state);

  return (
    <Page className={classes.root} title="Distribution Type Create">
      <Container maxWidth={false} className={classes.container}>
        <Header />
        <DistributorEditForm  state={state}/>
      </Container>
    </Page>
  );
}

export default DistributorTypeEdit;

